import { getPublicImageUrl } from './storage';
import { API_URL } from './env';

export { API_URL };

// Constantes de imágenes
export const IMAGES = {
    HERO_BACKGROUND: getPublicImageUrl('hero-bg.avif', true),
    DEFAULT_PRODUCT: getPublicImageUrl('placeholder-product.jpg', true),
    // Institutional images
    INSTITUTIONAL_TEAM: getPublicImageUrl('institutional/equipo-profesional.jpg', true),
    INSTITUTIONAL_WAREHOUSE: getPublicImageUrl('institutional/deposito-moderno.jpg', true),
    INSTITUTIONAL_OFFICE: getPublicImageUrl('institutional/oficinas-atencion.jpeg', true),
    // Archived promo images (mantener para referencia)
    PROMO_3M: getPublicImageUrl('3m-promo.webps', true),
    PROMO_RINGO: getPublicImageUrl('ringo-promo.jpg', true),
    PROMO_EPP: getPublicImageUrl('epp-promo.jpg', true),
    FAVICON: getPublicImageUrl('favicon.jpg', true),
    LOGO: getPublicImageUrl('cr-work-logo3.png', true),
    LOADING_HELMET: getPublicImageUrl('helmet-bg.jpg', true),
};
